import { startHubspotConnect } from '../lib/api';
import { Postmark } from '../components/Postmark';

export function LoginPage() {
  return (
    <div className="page login">
      <Postmark />

      <span className="eyebrow">Outlook → HubSpot · since 2026</span>

      <h1>
        Bring your <em>whole</em> sales history into HubSpot.
      </h1>

      <p className="lead">
        Backfill your complete Outlook archive into HubSpot — every message
        back to day one — with conversation-aware filters, owner attribution,
        and a per-message audit log.
      </p>

      <button className="primary" onClick={startHubspotConnect}>
        Sign in with HubSpot →
      </button>

      <div className="receipt">
        <div className="receipt-row">
          <span>Sign in</span>
          <strong>HubSpot · select your portal</strong>
        </div>
        <div className="receipt-row">
          <span>Connect mailbox</span>
          <strong>Microsoft 365 · read-only</strong>
        </div>
        <div className="receipt-row">
          <span>Storage</span>
          <strong>IDs only · never your mail content</strong>
        </div>
      </div>
    </div>
  );
}
